import React from "react";
import "./Loading.css";

const Loading = () => {
  return <div class="loading">Loading&#8230;</div>;
};

export default Loading;
